<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- START Project section w/ 3 tilt cards -->
<section style="{style(block)}">
  <div class="container">
    <!-- <div class="row mb-5"> -->
    <!--   <div class="col-lg-8 text-center mx-auto"> -->
    <!--     <p class="mb-1">Our Work</p> -->
    <!--     <h3>Some of our awesome projects - 3</h3> -->
    <!--   </div> -->
    <!-- </div> -->
    <div class="row justify-content-center">
      {#each blocklist(block, 'projects') as project}
      <div class="col-lg-4 col-md-6 mb-4">
        <a href="{url(project, 'link')}">
          <div class="card card-background card-background-mask-primary tilt h-100" data-tilt>
            <div class="full-background" style="background-image: url({image(project, 'background', [null, 500])})"></div>
            <div class="card-body pt-5 text-center">
              <div class="icon icon-lg up mb-5">
                <img src="{image(project, 'icon', [null, 100])}" alt="">
              </div>
              <div style="min-height: 100px">
                <h3 class="text-white up mb-5">{text(project, 'title')}</h3>
              </div>
              <div style="min-height: 250px">
                <h5 class="text-white">{text(project, 'body')}</h5>
                <p class="lead up">{text(project, 'subtitle')}</p>
              </div>
              <a href="{url(project, 'button')}" class="btn btn-outline-white btn-lg mt-3 up h5">
                {text(project, 'button')}
              </a>
            </div>
          </div>
        </a>
      </div>
      {/each}
    </div>
  </div>
</section>
<!-- END Project section w/ 3 images & quote & text -->
